import { HorizontalContainer } from '@american-autonomy/ag-ui';

import ServiceIntervalsButton from 'components/ServiceIntervalsButton';
import PageTitle from 'components/text/PageTitle';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const MaintenancePageHeader: FunctionComponent<Props> = ({
    className = '',
    testId = TEST_ID,
    title
}) => (
    <HorizontalContainer className={`${className} ${styles.maintenancePageHeader}`} testId={testId}>
        <PageTitle text={title} />

        <ServiceIntervalsButton className={styles.serviceIntervalsButton} />
    </HorizontalContainer>
);

export default MaintenancePageHeader;
